import _extends from "@babel/runtime/helpers/extends";
import { createRelatedProductsComponent } from '@algolia/recommend-vdom';
import React, { createElement, Fragment } from 'react';
import { useRelatedProducts } from './useRelatedProducts';
const UncontrolledRelatedProducts = createRelatedProductsComponent({
  createElement,
  Fragment
});
export function RelatedProducts(props) {
  const {
    recommendations,
    status
  } = useRelatedProducts(props);
  return /*#__PURE__*/React.createElement(UncontrolledRelatedProducts, _extends({}, props, {
    items: recommendations,
    status: status
  }));
}